<!-- ai 案例 -->
<template>
  <div class="case">
    <h4 class="current">您的位置：<router-link to="/home">首页 </router-link> &gt;资讯中心</h4>
    <div class="article">
      <h5>国务院办公厅：药占比、耗占比考核都没了？</h5>
      <h6>2019-02-02 &nbsp;&nbsp;&nbsp;&nbsp; 来源：健康界</h6>
      <p></p>
      <span class="boldblack font18">耗占比取消了？</span>
      <p>
        2019年1月30日，国务院办公厅印发《关于加强三级公立医院绩效考核工作的意见》，要求在2019年12月底前完成第一次全国三级公立医院绩效考核工作。
      </p>

      <img style="width: 650px" src="@/assets/news3-1.png" />

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三级公立医院绩效考核指标体系由医疗质量、运营效率、持续发展、满意度评价等4个方面的55项指标构成。指标供各地使用，同时确定部分指标作为国家监测指标，要求在2019年6月底前各省份要出台具体实施方案。
        <br /><br /><span class="boldblack font18">绩效考核结果</span> <br /><br />
        l 作为公立医院发展规划、重大项目立项、财政投入、经费核拨、绩效工资总量核定、医保政策调整的重要依据，<br />
        l 与医院评审评价、国家医学中心和区域医疗中心建设以及各项评优评先工作紧密结合，<br />
        l 作为选拔任用公立医院党组织书记、院长和领导班子成员的重要参考。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;从绩效考核实施的急迫性和考核结果的关联性可以看出，这次考核工作是个“重头戏”，但在这“重头戏”中却不见对耗占比的考核，是否可以认定“控制耗占比”已不再作为医院考核指标呢？
        <br /><br /><span class="boldblack font18">“药占比”没了？</span> <br /><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在三级公立医院绩效考核中对合理用药提供了新的意见，不妨先看看主管部门如何看待药占比。
        在实施药占比的过程中的确出现了不少问题，比如因为药占比的问题，一些救命药、短缺药在医院开不到；在最后一两个月药占比已超标，部分医生不给病人开药或者直接让病人去药房买。
        国家卫生健康委医政医管局局长张宗久先生认为药占比这个指标相对来说比较粗放。而药品在整个收入结构中的占比，如何转化为医务人员的高质量的医疗服务，这是很关键的。
        这次绩效考核，使用了合理用药的相关指标取代了单一使用药占比进行考核，把医务人员每一张处方的合理性和病人用药的质量安全放在一个更加突出的位置上，对相关指标进行考核。
        先药后械，虽然此次绩效考核指标中没有出现“耗占比”的身影，但从官方的态度来看，是愿意放弃原先粗放的形式，把重心放在更符合实际的药品（耗材）使用和高质量的医疗服务中。
        <br /><br />
        <span class="boldblack font18">“耗占比”没了？</span><br /><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2015年5月，国办印发了《关于城市公立医院综合改革试点的指导意见》，要求试点城市公立医院药占比（不含中药饮片）总体降到30%左右；百元医疗收入（不含药品收入）中消耗的卫生材料降到20元以下。
        这是降低耗占比的源头，此后全国各省市开展了与耗占比轰轰烈烈的“斗争”。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;例如在2017年底，四川省一共有39家三甲医院的医疗费用增长幅度超过10%，四川、山东多家大医院为降耗占比，限用、停用耗材闹得沸沸扬扬。
        甚至有不少地方施行“一刀切”，医院的耗占比一律下降到20%以下。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;但实际上，不同的医院耗占比是不同的。医院级别越高，进行的手术越复杂，使用的耗材也相对高端，耗占比一般也就更高，而较小的医院往往承担常见疾病的治疗，更多是低值消耗。
        各科室的耗占比也是不一样的。比如一般外科能达到25%左右，耳鼻喉在百分之七八，糖尿病医院低；骨科、血管外科、脊柱科、大血管等，比例都很高。
        甚至有业内人士表示，如果三级医院都将耗占比下降到20%，会影响新技术和新材料的使用，最后导致医疗水平倒退10年。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;于是在2018年3月，在国家卫健委联合5部委发布的《关于巩固破除以药补医成果持续深化公立医院综合改革的通知》中明确，将控费指标细化分解到每家医院，不搞“一刀切”。
        根据耗占比的计算公式，除了不同医院不同指标，耗材价格和医院收入结构也是耗占比的决定因素之一，这与近年来国家要求耗材集采降价和提高医疗服务收入的举措是相呼应的。
        虽然耗占比并未出现在此次医院绩效考核中，但依旧可以反映在“医疗服务收入占医疗收入比例”中，“门诊收入中来自医保基金的比例”和“住院收入中来自医保基金的比例”也依旧举着控费大旗。另外文件中也提到，各地可以结合实际，适当补充部分指标。
        说到底，“耗占比”“药占比”是各方焦虑的聚集点，只要革命还未成功，依旧会出现其他形式的“耗占比”和“药占比”。大家也不过希望医疗市场大好，治病少花点钱，医保压力减轻。
        只是最好的路到底在哪里？还在摸索中。
      </p>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
h4.current {
  display: block;
  height: 40px;
  line-height: 30px;
  background: url(../../../assets/currentbg.jpg) repeat-x bottom;
  color: #333;
}
h4.current a:hover {
  color: #e90000;
}
.article h5 {
  display: block;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #333;
  margin-top: 40px;
}
.article h6 {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 5px;
  margin-bottom: 30px;
}
.smalltit {
  display: block;
  height: 55px;
  line-height: 55px;
  margin-top: 20px;
  padding-left: 35px;
  background: url(../../../assets/ico01.png) no-repeat left center;
  font-size: 22px;
  color: #e60212;
}
.intro p {
  line-height: 30px;
}
.intro img {
  display: block;
  margin: 0 auto;
}
.article img {
  margin: 0 auto;
  display: block;
  margin-top: 15px;
}
.article p {
  margin-top: 15px;
  line-height: 30px;
  margin: 15px 0;
}
.boldblack {
  color: #333;
  font-weight: bold;
}
.boldred {
  color: #f00;
  font-weight: bold;
}
.font18 {
  font-size: 18px;
}
</style>
